// extracted by mini-css-extract-plugin
export default {"Checkbox":"Checkbox_Checkbox__TS6Zb","MultiSelect":"Checkbox_MultiSelect__4wnWW","Disabled":"Checkbox_Disabled__AqgQ2","Checkmark":"Checkbox_Checkmark__15cwX"};